module.exports = __webpack_public_path__ + "static/media/insta.fa460c3f.jpg";